import {ActionTypes} from '../../actions';
import createReducer from '../../../common/util/createReducer';

const INITIAL_STATE = {
  'userNotifyLoading': false,
  'courseNotifyLoading': false,
};

export const wtsEmailNotify = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.CREATING_WTS_USER_NOTIFY]: (state, action) => ({
      ...state,
      'userNotifyLoading': true,
    }),
    [ActionTypes.CREATED_WTS_USER_NOTIFY]: (state, action) => ({
      ...state,
      'userNotifyLoading': false,
    }),
    [ActionTypes.CREATED_WTS_USER_NOTIFY_FAILED]: (state, action) => ({
      ...state,
      'userNotifyLoading': false,
    }),
    [ActionTypes.CREATING_WTS_COURSE_NOTIFY]: (state, action) => ({
      ...state,
      'courseNotifyLoading': true,
    }),
    [ActionTypes.CREATED_WTS_COURSE_NOTIFY]: (state, action) => ({
      ...state,
      'courseNotifyLoading': false,
    }),
    [ActionTypes.CREATED_WTS_COURSE_NOTIFY_FAILED]: (state, action) => ({
      ...state,
      'courseNotifyLoading': false,
    }),
    [ActionTypes.UPDATING_WTS_USER_NOTIFY]: (state, action) => ({
      ...state,
      'userNotifyLoading': true,
    }),
    [ActionTypes.UPDATED_WTS_USER_NOTIFY]: (state, action) => ({
      ...state,
      'userNotifyLoading': false,
    }),
    [ActionTypes.UPDATED_WTS_USER_NOTIFY_FAILED]: (state, action) => ({
      ...state,
      'userNotifyLoading': false,
    }),
    [ActionTypes.UPDATING_WTS_COURSE_NOTIFY]: (state, action) => ({
      ...state,
      'courseNotifyLoading': true,
    }),
    [ActionTypes.UPDATED_WTS_COURSE_NOTIFY]: (state, action) => ({
      ...state,
      'courseNotifyLoading': false,
    }),
    [ActionTypes.UPDATED_WTS_COURSE_NOTIFY_FAILED]: (state, action) => ({
      ...state,
      'courseNotifyLoading': false,
    }),
    [ActionTypes.CLOSING_WTS_COURSE_NOTIFY]: (state, action) => ({
      ...state,
      'courseNotifyLoading': true,
    }),
    [ActionTypes.CLOSED_WTS_COURSE_NOTIFY]: (state, action) => ({
      ...state,
      'courseNotifyLoading': false,
    }),
    [ActionTypes.CLOSED_WTS_COURSE_NOTIFY_FAILED]: (state, action) => ({
      ...state,
      'courseNotifyLoading': false,
    }),
    [ActionTypes.CANCELLING_WTS_COURSE_NOTIFY]: (state, action) => ({
      ...state,
      'courseNotifyLoading': true,
    }),
    [ActionTypes.CANCELLED_WTS_COURSE_NOTIFY]: (state, action) => ({
      ...state,
      'courseNotifyLoading': false,
    }),
    [ActionTypes.CANCELLED_WTS_COURSE_NOTIFY_FAILED]: (state, action) => ({
      ...state,
      'courseNotifyLoading': false,
    }),
  })(state, action);
};
